import * as React from 'react';
import { injectIntl, WrappedComponentProps as InjectedIntlProps } from 'react-intl';

import { FieldSet, PasswordInput } from '..';
import { localeData } from '../../../locales/data';
import { addModifiers } from '../../../shared/helpers';

import { PasswordGenerator } from '.';
import { StrictPopupProps } from 'semantic-ui-react/dist/commonjs/modules/Popup/Popup';

interface PasswordMainProps {
  tabIndexPassword?: number;
  tabIndexConfirmPassword?: number;
  passwordRequired?: boolean;
  confirmPasswordRequired?: boolean;
  confirmPasswordHidden?: boolean;
  passwordLabel?: string;
  passwordName?: string;
  modifiers?: string[];
  passwordModifiers?: string[];
  handleChangeField: (event: any, data: any) => void;
  handleBlurField?: (event: React.FocusEvent<HTMLInputElement>) => void;
  passwordValue: string;
  passwordErrors: any;
  confirmPasswordValue: string;
  confirmPasswordErrors: any;
  autoFocus?: boolean;
  guidelinesPosition?: StrictPopupProps['position'];
}

const PasswordMain = ({
  intl,
  passwordErrors,
  confirmPasswordErrors,
  tabIndexPassword,
  passwordValue,
  tabIndexConfirmPassword,
  confirmPasswordValue,
  passwordLabel = 'password.label',
  passwordName = 'password',
  modifiers = [],
  passwordModifiers = [],
  passwordRequired = true,
  confirmPasswordRequired = true,
  confirmPasswordHidden = false,
  handleChangeField,
  handleBlurField,
  autoFocus,
  guidelinesPosition,
}: PasswordMainProps & InjectedIntlProps) => (
  <div className={addModifiers('form__grid', modifiers)}>
    <div className="form__grid-item">
      <PasswordGenerator
        label={intl.formatMessage({ id: passwordLabel, defaultMessage: localeData.en[passwordLabel] })}
        name={passwordName}
        value={passwordValue}
        handleChange={handleChangeField}
        handleBlur={handleBlurField}
        errors={passwordErrors}
        id={passwordName}
        tabindex={tabIndexPassword}
        modifiers={passwordModifiers}
        required={passwordRequired}
        autoFocus={autoFocus}
        guidelinesPosition={guidelinesPosition}
      />
    </div>
    {!confirmPasswordHidden && (
      <div className="form__grid-item">
        <FieldSet errors={confirmPasswordErrors} label="password.confirm.label" required={confirmPasswordRequired} id="current-password">
          <PasswordInput
            className="form__input"
            name="confirmation"
            id="confirm-password"
            tabIndex={tabIndexConfirmPassword}
            value={confirmPasswordValue}
            onChange={handleChangeField}
            onBlur={handleBlurField}
          />
        </FieldSet>
      </div>
    )}
  </div>
);

export default injectIntl(PasswordMain);
